import { jsonb, pgTable, text, timestamp, uniqueIndex } from "drizzle-orm/pg-core";

/**
 * A Roca sorter batch saved from the inventory page, so it can be added after
 * the cards are sleeved. Platform staff write it. `file_key` is
 * `roca/{csv name}-{batch name}`, the key Retool stored under `roca/` in S3.
 * The body never reaches a tenant.
 */
export const rocaBatches = pgTable(
  "roca_batches",
  {
    id: text("id").primaryKey(),
    fileKey: text("file_key").notNull(),
    fileName: text("file_name").notNull(),
    batchName: text("batch_name").notNull(),
    category: text("category").notNull(),
    printing: text("printing").notNull(),
    /** Matched cards that were not pulled for value, the Retool `entries` list. */
    entries: jsonb("entries").notNull(),
    /**
     * When the sleeved steps last added this file to inventory. Null until
     * then, and after a later save replaces the file.
     */
    addedAt: timestamp("added_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (table) => [uniqueIndex("roca_batches_file_key_idx").on(table.fileKey)],
);
